import React from 'react';
import * as Unicons from '@iconscout/react-unicons';
import ResourceHubHero1 from '../../../assets/images/hcp-landing/resource-hub-hero1.svg';
import ResourceHubHero2 from '../../../assets/images/hcp-landing/resource-hub-hero2.svg';

const AreYouHCP = () => {
  return (
    <div className="resource-hub areyou-hcp">
      <div className="content-section resource-hub-info">
        <h2 class="title__homepage-large title__black100">
          Are you a{' '}
          <span class="title__secondary100">healthcare provider?</span>
        </h2>
        <p className="paragraph">
          Learn more about EczemaWise for your patients.
        </p>
        <a href="/for-healthcare-providers">
          <button>
            <Unicons.UilArrowRight size="16" />
            Learn more
          </button>
        </a>
      </div>
      <div className="resource-hub-hero">
        <img src={ResourceHubHero1} alt="" />
        <img src={ResourceHubHero2} alt="" className="hero2" />
      </div>
    </div>
  );
};

export default AreYouHCP;
